/**
 * Password Reset Done page - shown after requesting a password reset email
 * Replaces account/password_reset_done.html template
 */
import { Box, Link, Typography } from "@mui/material";
import { AuthLayout, BRAND_COLORS } from "../components/AuthLayout";
import { gettext } from "@services/i18n";

export function PasswordResetDonePage() {
  return (
    <AuthLayout title={gettext("Password Reset Email Sent")}>
      <Box
        sx={{
          padding: "0 2.5rem 2.5rem",
          backgroundColor: "white",
          textAlign: "center",
        }}
      >
        <Typography
          sx={{
            fontSize: "0.875rem",
            color: BRAND_COLORS.text.secondary,
            marginBottom: "1rem",
          }}
        >
          {gettext(
            "We have sent you an e-mail. If you have not received it please check your spam folder. Otherwise contact us if you do not receive it in a few minutes.",
          )}
        </Typography>

        <Link
          href="/accounts/login/"
          sx={{
            display: "block",
            marginTop: "2rem",
            color: BRAND_COLORS.link,
            fontSize: "0.875rem",
            textDecoration: "none",
            fontWeight: 500,
            "&:hover": {
              color: BRAND_COLORS.linkHover,
              textDecoration: "underline",
            },
          }}
          data-testid="back-to-login-link"
        >
          {gettext("Back to Sign In")}
        </Link>
      </Box>
    </AuthLayout>
  );
}
